import React from "react";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import Link from "components/elements/link";
import SVG from "components/elements/svg";
import TextContent from "components/elements/text-content";
import Integrations from "components/partials/integrations";

const HowItWorks = () => (
  <Layout className="how-it-works" title="How it works">
    <Header>
      <HeaderBanner
        title="How it works"
        icon="home"
        background="/static/images/header-how-it-works.jpg"
      />
    </Header>

    <Breadcrumbs>
      <Breadcrumbs.Item title="How it works" url="how-it-works" />
    </Breadcrumbs>

    <section className="how-it-works__content">
      <div className="container">
        <h2 className="section-heading center">
          Click an account type to learn more.
        </h2>

        <div className="row">
          <div className="col-md-6 col-xs-12">
            <div className="box" role="button" tabIndex="0">
              <SVG src="reasons-2" className="icon" />

              <div className="content">
                <h3 className="title">How it works - Buyer</h3>

                <TextContent>
                  <p>
                    Mortgage buyers welcome, with up to 90 days to complete. No
                    fees guaranteed, unless you win the auction.
                  </p>
                </TextContent>
              </div>

              <Link to="how-it-works/buyer" />
            </div>
          </div>

          <div className="col-md-6 col-xs-12">
            <div className="box" role="button" tabIndex="0">
              <SVG src="for-sale" className="icon" />

              <div className="content">
                <h3 className="title">How it works - Seller</h3>

                <TextContent>
                  <p>
                    You can sell your property for FREE, at a price you want and
                    in just 28 days. The buyer pays a reservation fee on winning
                    the auction.
                  </p>
                </TextContent>
              </div>

              <Link to="how-it-works/seller" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <Integrations />
  </Layout>
);

export default asPage(HowItWorks);
